import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Layout, Button, Row, Col, message, Modal, Divider, Form, DatePicker, Select, Input } from "antd";
import {
  AimOutlined,
  CameraOutlined,
  CheckOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { getBundleService, getMetalsService, postBundleService, putBundleService } from "./NewBundlePageService";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import ScaleReading from "../../components/ScaleReading/ScaleReading";
import PurchaseForm from "../../components/PurchaseForm/PurchaseForm";
import Loader from "../../components/Loader/Loader";
import "./NewBundlePage.css";
import { removeTokenFromCookies } from "../../utils/cookies";
import Cookies from "universal-cookie";
import Copyright from "../../components/Copyright/Copyright";
import ScaleCamera from "../../components/ScaleCamera/ScaleCamera";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import TextArea from "antd/es/input/TextArea";
import { webcamDeviceIDs } from "../../constants/webcamIDs";

const { Content } = Layout;

export interface NewBundlePageProps {
  scaleSerialPort: any;
  scaleReader: any;
  updateScaleSerialPort: (port: any) => void;
  updateScaleReader: (reader: any) => void;
}

const NewBundlePage = (props: NewBundlePageProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [weight, setWeight] = useState("0.0");
  const [materialID, setMaterialID] = useState("");
  const [portAccessModalOpen, setPortAccessModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [weightReadingTextDummy, setWeightReadingTextDummy] = useState("");
  const [scaleImageSrc, setScaleImageSrc] = useState(null);
  const [isDateChanged, setIsDateChanged] = useState(false);
  const [dateSelectedFormStatus, setDateSelectedFormStatus] = useState("") as any;
  const [dateSelectedFormMessage, setDateSelectedFormMessage] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [loadedBundle, setLoadedBundle] = useState({}) as any;
  const [metals, setMetals] = useState([]);
  const [enableManualEntry, setEnableManualEntry] = useState(false);
  const [rawWeightFormStatus, setRawWeightFormStatus] = useState("") as any;
  const [rawWeightFormMessage, setRawWeightFormMessage] = useState("");
  const [wasteWeightFormStatus, setWasteWeightFormStatus] = useState("") as any;
  const [wasteWeightFormMessage, setWasteWeightFormMessage] = useState("");
  const [materialNameFormStatus, setMaterialNameFormStatus] = useState("") as any;
  const [materialNameFormMessage, setMaterialNameFormMessage] = useState("");
  const [materialIDFromURL, setMaterialIDFromURL] = useState("");
  const [bundleInfo, setBundleInfo] = useState({
    materialID: uuidv4(),
    name: "",
    displayName: "",
    metalID: "",
    rawWeight: "0.0",
    wasteWeight: "0.0",
    netWeight: "0.0",
    manualEntry: false,
    notes: "",
    scaleImageSrc: null,
  });
  const [materialsNameList, setMaterialsNameList] = useState([]) as any;
  let location = useLocation();
  let navigate = useNavigate();
  const cookies = new Cookies();
  const token = cookies.get("TOKEN");
  const webcamRef = useRef(null) as any;
  const currOffice = cookies.get("CURR_OFFICE");

  useEffect(() => {
    navToSelectOffice();
    getMetals();
    isPortEnabled();
  }, [token, props.scaleSerialPort]);

  useEffect(() => {
    if (props.scaleReader !== null) getReadingValue(props.scaleReader);
  }, [props.scaleReader, weightReadingTextDummy]);

  // useEffect(() => {
  //   const IDFromURL = location.pathname.split("/")[2];
  //   setMaterialIDFromURL(IDFromURL);
  //   if (IDFromURL !== undefined) loadBundleInfo(IDFromURL);
  //   // else resetPurchaseInfo();
  // }, [purchaseIDFromURL, location.pathname]);

  const navToSelectOffice = () => {
    if (currOffice === "" || currOffice === undefined || currOffice === null) navigate("/");
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const isPortEnabled = () => {
    if (props.scaleSerialPort === null) setPortAccessModalOpen(true);
    // if (scaleSerialPort === null) setPortAccessModalOpen(true);
  };

  const getBundle = async (materialIDFromURL: string) => {
    try {
      setLoading(true);
      const res = await getBundleService(materialIDFromURL);
      setMaterialID(res.data.materialID);
      setLoading(false);
      return res.data;
    } catch (e: any) {
      setLoading(false);
      console.error("getBundle error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const generateMaterialsList = (metalsData: any) => {
    const sortedAllMaterialsList = metalsData;
    const sortedAllMaterialsListDropdown = sortedAllMaterialsList.map((metal: any) => {
      return {
        label: metal.displayName,
        value: metal.metalID,
      };
    });
    setMaterialsNameList(sortedAllMaterialsListDropdown);
  };

  const toggleSidebar = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  const getMetals = async () => {
    try {
      setLoading(true);
      const res = await getMetalsService();
      setMetals(res.data);
      generateMaterialsList(res.data);
      setLoading(false);
      return res.data;
    } catch (e: any) {
      setLoading(false);
      console.error("getMetals error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  // const postSupplierSelected = async (supplierID: string, dateString: string) => {
  //   try {
  //     const dateProperties = dateString.split("/");
  //     const date =
  //       dateString !== "" && dateString !== undefined
  //         ? new Date(`${dateProperties[2]}-${dateProperties[1]}-${dateProperties[0]}`).toISOString()
  //         : new Date().toISOString();
  //     setLoading(true);
  //     const payload = {
  //       supplierID: supplierID,
  //       office: "pg",
  //       date: date,
  //     };
  //     const res = await postSupplierSelectedService(payload);
  //     if (res.data.purchaseID) {
  //       setPurchaseID(res.data.purchaseID);
  //       window.history.pushState(null, "", `purchase/${res.data.purchaseID}`);
  //     }
  //     setLoading(false);
  //   } catch (e: any) {
  //     setLoading(false);
  //     console.error("postSupplierSelected error", e);
  //     if (e.response.status === 401) {
  //       removeTokenFromCookies();
  //       navToLogin();
  //     }
  //   }
  // };

  const putBundle = async (materialInfo: any) => {
    try {
      setLoading(true);
      const payload = {
        materialID: materialInfo.materialID,
        name: materialInfo.name,
        rawWeight: materialInfo.rawWeight,
        wasteWeight: materialInfo.wasteWeight,
        netWeight: materialInfo.netWeight,
        manualEntry: materialInfo.manualEntry,
        smallBag: materialInfo.smallBag,
        bigBag: materialInfo.bigBag,
        jumboBag: materialInfo.jumboBag,
        other: materialInfo.other,
        metalID: materialInfo.metalID,
        scaleImageSrc: scaleImageSrc,
        notes: materialInfo.notes,
      };
      const res = await putBundleService(payload);
      setScaleImageSrc(null);
      setLoading(false);
      return res;
    } catch (e: any) {
      setLoading(false);
      console.error("putBundle error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const postBundle = async () => {
    try {
      setLoading(true);
      const payload = {
        rawWeight: bundleInfo.rawWeight,
        wasteWeight: bundleInfo.wasteWeight,
        netWeight: bundleInfo.netWeight,
        price: 0.0,
        notes: bundleInfo.notes,
        manualEntry: bundleInfo.manualEntry,
        office: currOffice,
        metalID: bundleInfo.metalID,
        scaleImageSrc: scaleImageSrc,
      };
      const res = await postBundleService(payload);
      setScaleImageSrc(null);
      setRawWeightFormStatus("");
      setRawWeightFormMessage("");
      setWasteWeightFormStatus("");
      setWasteWeightFormMessage("");
      setMaterialNameFormStatus("");
      setMaterialNameFormMessage("");
      setLoading(false);
      navigate("/bundles");
      // return res.data;
    } catch (e: any) {
      setLoading(false);
      console.error("postBundle error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const recordRawWeight = () => {
    setScaleImageSrc(null);
    setTimeout(() => {
      recordScaleImage();
    }, 1000);
    return Number(weight).toFixed(1);
  };

  const recordScaleImage = useCallback(() => {
    if (scaleImageSrc === null) {
      if (webcamRef.current !== null) {
        const imageSrc = webcamRef.current.getScreenshot();
        setScaleImageSrc(imageSrc);
        return imageSrc;
      } else {
        setScaleImageSrc(null);
        setTimeout(() => {
          const imageSrc = webcamRef.current.getScreenshot();
          setScaleImageSrc(imageSrc);
          return imageSrc;
        }, 1000);
      }
    }
  }, [webcamRef]);

  const resetImageView = () => {
    setScaleImageSrc(null);
  };

  const getReadingValue = async (reader: any) => {
    let weightReadingText = "";
    const { value, done } = await reader.read();
    setWeightReadingTextDummy(String(Math.random()));
    if (value) {
      weightReadingText += value;
      // console.log("reading,", weightReadingText);
      if (/\r\n/i.test(weightReadingText)) {
        let recordWeight = weightReadingText.trim().split("kg")[0];
        // console.log("raw", weightReadingText.trim().split("kg"));
        // console.log("net", recordWeight);
        // console.log("number", Number(recordWeight).toFixed(1));
        setWeight(Number(recordWeight).toFixed(1));
        weightReadingText = "";
      }
    }
    if (done) {
      reader.releaseLock();
    }
  };

  const getPortAccess = async () => {
    try {
      setPortAccessModalOpen(false);
      const port = await (window.navigator as any).serial.requestPort();
      props.updateScaleSerialPort(port);
      await port.open({ baudRate: 9600, bufferSize: 1000000 });
      const textDecoder = new TextDecoderStream();
      port.readable.pipeTo(textDecoder.writable);
      const reader = textDecoder.readable.getReader();
      props.updateScaleReader(reader);
    } catch (e: any) {
      setPortAccessModalOpen(false);
      console.error("getPortAccess error", e);
    }
  };

  const updateLoading = (loading: boolean) => {
    setLoading(loading);
  };

  const resetNewPurchasePage = () => {
    toggleSidebar(true);
  };

  // const deleteMaterial = async (materialID: string) => {
  //   try {
  //     setLoading(true);
  //     const payload: any = {
  //       materialID: materialID,
  //       purchaseID: purchaseID,
  //       office: currOffice
  //     };
  //     const res = await deleteMaterialService(payload);
  //     setLoading(false);
  //   } catch (e: any) {
  //     setLoading(false);
  //     console.error("deleteMaterial error", e);
  //     if (e.response.status === 401) {
  //       removeTokenFromCookies();
  //       navToLogin();
  //     }
  //   }
  // };

  const isNewBundle = () => {
    return location.pathname.split("/")[2] === undefined;
  };

  const updateBundleDate = (dateString: string) => {
    setDateSelectedFormStatus("");
    setDateSelectedFormMessage("");
    setSelectedDate(dateString);
  };

  const getUpdatedDate = () => {
    const dateProperties = selectedDate.split("/");
    return new Date(`${dateProperties[2]}-${dateProperties[1]}-${dateProperties[0]}`).toLocaleDateString("en-GB");
  };

  const updateSetIsDateChanged = () => {
    setIsDateChanged(true);
  };

  const updateMaterialName = (metalID: any) => {
    const selectedBundle: any = metals.find((metal: any) => metal.metalID === metalID);
    setMaterialNameFormStatus("");
    setMaterialNameFormMessage("");
    let bundle = { ...bundleInfo };
    bundle.name = selectedBundle.name;
    bundle.displayName = selectedBundle.displayName;
    bundle.metalID = selectedBundle.metalID;
    setBundleInfo(bundle);
  };

  const updateWasteWeight = (wasteWeight: string) => {
    setWasteWeightFormStatus("");
    setWasteWeightFormMessage("");
    let bundle = { ...bundleInfo };
    const netWeight = Number(bundle.rawWeight) - Number(wasteWeight);
    bundle.wasteWeight = wasteWeight;
    // material.wasteWeight = Number(wasteWeight).toFixed(1);
    bundle.netWeight = netWeight.toFixed(1);
    setBundleInfo(bundle);
  };

  const updateRawWeight = (rawWeight: string, manualEntry: boolean) => {
    if (Number(rawWeight) <= 0.0) {
      setRawWeightFormStatus("error");
      setRawWeightFormMessage("Must be more than 0.0 kg");
    } else {
      setRawWeightFormStatus("");
      setRawWeightFormMessage("");
    }
    let bundle = { ...bundleInfo };
    const netWeight = Number(rawWeight) - Number(bundle.wasteWeight);
    bundle.rawWeight = rawWeight;
    // material.rawWeight = Number(rawWeight).toFixed(1);
    bundle.netWeight = netWeight.toFixed(1);
    bundle.manualEntry = manualEntry;
    setBundleInfo(bundle);
  };

  const updateManualEntry = () => {
    let bundle = { ...bundleInfo };
    bundle.manualEntry = true;
    setBundleInfo(bundle);
    setEnableManualEntry(true);
  };

  const recordWeightEntry = () => {
    setEnableManualEntry(false);
    let rawWeight = recordRawWeight();
    console.log("rawWeight", rawWeight);
    updateRawWeight(rawWeight, false);
  };

  const captureScaleImage = () => {
    let scaleImage = recordScaleImage();
  };

  const updateNotes = (text: string) => {
    let bundle = { ...bundleInfo };
    bundle.notes = text;
    setBundleInfo(bundle);
  };

  const validateForm = () => {
    let bundle = { ...bundleInfo };
    let validationFormStatus = true;
    if (bundle.name === "") {
      validationFormStatus = false;
      setMaterialNameFormStatus("error");
      setMaterialNameFormMessage("Select a material");
    }
    if (Number(bundle.rawWeight) <= 0.0) {
      validationFormStatus = false;
      setRawWeightFormStatus("error");
      setRawWeightFormMessage("Must be more than 0.0 kg");
    }
    if (Number(bundle.wasteWeight) < 0.0) {
      validationFormStatus = false;
      setWasteWeightFormStatus("error");
      setWasteWeightFormMessage("Cannot be lower than 0.0 kg");
    }
    return validationFormStatus;
  };

  // const addToMaterialsList = () => {
  //   // props.addToMaterialsList(materialInfo);
  //   // resetMaterialInfo();
  //   // isManualEntry();
  //   setRawWeightFormStatus("");
  //   setRawWeightFormMessage("");
  //   setWasteWeightFormStatus("");
  //   setWasteWeightFormMessage("");
  //   setMaterialNameFormStatus("");
  //   setMaterialNameFormMessage("");
  // };

  // const saveToMaterialsList = () => {
  //   // props.saveToMaterialsList(materialInfo);
  //   // resetMaterialInfo();
  //   // isManualEntry();
  //   setRawWeightFormStatus("");
  //   setRawWeightFormMessage("");
  //   setWasteWeightFormStatus("");
  //   setWasteWeightFormMessage("");
  //   setMaterialNameFormStatus("");
  //   setMaterialNameFormMessage("");
  // };

  return (
    <Layout>
      <Loader loading={loading} />
      <Modal
        title="Allow COM port for Scale Reading (RS323)"
        open={portAccessModalOpen}
        okText="Allow"
        cancelButtonProps={{ style: { display: "none" } }}
        onOk={getPortAccess}
        onCancel={() => setPortAccessModalOpen(false)}
      >
        <p>Select 'USB-Serial Controller (COM3)' and press Connect</p>
      </Modal>
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <Content>
        <Col span={24}>
          <Header toggleSidebar={toggleSidebar} />
          <Row className="new-bundle-container">
            <Col style={{ width: "30%" }}>
              <Row className="new-bundle-weight-reading">
                <ScaleReading weight={weight} scaleSerialPort={props.scaleSerialPort} getPortAccess={getPortAccess} />
              </Row>
              <Row className="new-bundle-image-capture">
                <ScaleCamera
                  webcamRef={webcamRef}
                  webcamName="Scale"
                  imageSrc={scaleImageSrc}
                  deviceID={webcamDeviceIDs.scaleCameraPG}
                />
              </Row>
              <Row className="new-bundle-image-capture">
                <ScaleCamera
                  webcamRef={webcamRef}
                  webcamName="Material"
                  imageSrc={scaleImageSrc}
                  deviceID={webcamDeviceIDs.materialCameraPG}
                />
              </Row>
            </Col>
            <Col style={{ width: "70%" }} className="new-bundle-form">
              <Row>
                <Col span={12}>
                  <Row justify="start">
                    <h2>New Bundle</h2>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row justify="end">
                    {isNewBundle() ? (
                      isDateChanged ? (
                        <Form layout="vertical">
                          <Form.Item validateStatus={dateSelectedFormStatus} help={dateSelectedFormMessage}>
                            <DatePicker
                              allowClear={false}
                              onChange={(date, dateString) => updateBundleDate(dateString)}
                              format={"DD/MM/YYYY"}
                              showToday
                              disabledDate={(current) => {
                                let customDate = moment().add(1, "day").format("YYYY-MM-DD");
                                return current && current > moment(customDate, "YYYY-MM-DD");
                              }}
                            />
                          </Form.Item>
                        </Form>
                      ) : (
                        <>
                          {loadedBundle.createdTimestamp !== undefined ? (
                            <h2>{new Date(loadedBundle.createdTimestamp).toLocaleDateString("en-GB")}</h2>
                          ) : selectedDate !== "" ? (
                            <h2>{getUpdatedDate()}</h2>
                          ) : (
                            <h2>{new Date().toLocaleDateString("en-GB")}</h2>
                          )}
                          <Button
                            type="default"
                            onClick={() => updateSetIsDateChanged()}
                            icon={<EditOutlined />}
                            style={{ marginLeft: "10px" }}
                          ></Button>
                        </>
                      )
                    ) : (
                      <h2>{new Date(loadedBundle.createdTimestamp).toLocaleDateString("en-GB")}</h2>
                    )}
                  </Row>
                </Col>
              </Row>
              <Row>
                <Divider style={{ margin: "12px 0" }} />
              </Row>
              <div>
                <Form layout="vertical">
                  <Row className="material-dropdown-container">
                    <Col span={24}>
                      <Form.Item
                        label={<label className="material-form-label">Material Name*</label>}
                        validateStatus={materialNameFormStatus}
                        help={materialNameFormMessage}
                      >
                        <Select
                          showSearch
                          placeholder="Select a Material"
                          onChange={(value: any) => updateMaterialName(value)}
                          value={bundleInfo.displayName ? bundleInfo.displayName : null}
                          onSearch={() => {}}
                          options={materialsNameList}
                          style={{ width: "100%" }}
                          filterOption={(input: any, option: any) => {
                            return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      {enableManualEntry ? (
                        <Form.Item
                          label={<label className="material-form-label">Raw Weight*</label>}
                          validateStatus={rawWeightFormStatus}
                          help={rawWeightFormMessage}
                        >
                          <Input
                            placeholder="0.0"
                            style={{ width: "150px", marginRight: "5px" }}
                            value={bundleInfo.rawWeight}
                            onChange={(e) => {
                              updateRawWeight(e.target.value, true);
                            }}
                          />
                          <span>kg</span>
                        </Form.Item>
                      ) : (
                        <>
                          <div>
                            <span style={{ fontSize: "16px" }}>{bundleInfo.rawWeight} kg</span>
                          </div>
                          <div>
                            <span style={{ fontSize: "16px", color: "red" }}>{rawWeightFormMessage}</span>
                          </div>
                        </>
                      )}
                    </Col>
                    <Col span={12}>
                      <Row justify="end">
                        <Button
                          type="primary"
                          icon={<AimOutlined />}
                          style={{ width: "60%" }}
                          onClick={() => recordWeightEntry()}
                          disabled={props.scaleSerialPort === null ? true : false}
                        >
                          Record
                        </Button>
                      </Row>
                      <Row justify="end" style={{ marginTop: "10px" }}>
                        <Button
                          className="manual-entry-button"
                          type="primary"
                          icon={<EditOutlined />}
                          onClick={() => updateManualEntry()}
                        >
                          Manual Entry
                        </Button>
                        <Button
                          type="primary"
                          icon={<CameraOutlined />}
                          onClick={() => captureScaleImage()}
                          // disabled={props.scaleSerialPort === null ? true : false}
                        >
                          Manual Capture
                        </Button>
                      </Row>
                    </Col>
                  </Row>
                  <Row align="middle">
                    <Col span={12}>
                      <Row align="middle">
                        <Form.Item
                          label={<label className="material-form-label">Waste Weight*</label>}
                          validateStatus={wasteWeightFormStatus}
                          help={wasteWeightFormMessage}
                        >
                          <Input
                            placeholder="0.0"
                            style={{ width: "150px", marginBottom: "10px", marginRight: "5px" }}
                            value={bundleInfo.wasteWeight}
                            onClick={(e) =>
                              e.currentTarget.setSelectionRange(
                                e.currentTarget.value.length,
                                e.currentTarget.value.length
                              )
                            }
                            onChange={(e) => updateWasteWeight(e.target.value)}
                          />
                        </Form.Item>
                        <span>kg</span>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <Row style={{ margin: "10px 0" }} className="material-form-label">
                        Net Weight (kg)*
                      </Row>
                      <Row style={{ fontWeight: "bold", marginBottom: "15px" }}>{bundleInfo.netWeight} kg</Row>
                    </Col>
                    <Col span={12}>
                      <Row style={{ margin: "10px 0" }}>Notes</Row>
                      <Row>
                        <TextArea
                          showCount
                          style={{ height: 50 }}
                          onChange={(e) => updateNotes(e.target.value)}
                          placeholder="Enter bundle notes"
                        />
                      </Row>
                    </Col>
                  </Row>
                </Form>
                <Row justify="center" style={{ marginTop: "20px" }}>
                  <Button className="cancel-button" onClick={() => {}}>
                    Cancel
                  </Button>
                  <Button type="primary" icon={<CheckOutlined />} onClick={() => validateForm() && postBundle()}>
                    Add Bundle
                  </Button>
                  {/* <Button
                    type="primary"
                    icon={editBundleData ? <SaveOutlined /> : <CheckOutlined />}
                    onClick={() =>
                      editBundleData ? validateForm() && saveToMaterialsList() : validateForm() && addToMaterialsList()
                    }
                  >
                    {editBundleData ? "Save Bundle" : "Add Bundle"}
                  </Button> */}
                </Row>
              </div>
            </Col>
          </Row>
        </Col>
        <Copyright />
      </Content>
    </Layout>
  );
};

export default NewBundlePage;
